/* AthleteSwap — Hero-Video-Verhalten.

   Zwei getrennte, unabhängige Mechanismen in dieser Datei:

   1. initNativeHeroVideos(): der above-the-fold-Startseiten-Hero
      (data-as-hero-video-native). Das <video> steht dafür bereits fertig
      im server-gerenderten HTML (sections/as-editorial-voll.liquid) —
      keine DOM-Erzeugung per JS mehr, das ist auf iOS Safari robuster als
      ein nachträglich per createElement() eingefügtes Element. Dahinter
      liegt immer ein echtes <picture>-Poster im DOM. Das Video startet
      per CSS unsichtbar (opacity: 0) und wird hier erst sichtbar
      geschaltet, wenn das "loadeddata"-Event bestätigt, dass es
      tatsächlich ein Bild zu zeigen hat. Schlägt play() fehl oder feuert
      "error", bleibt es dauerhaft unsichtbar — das Poster darunter bleibt
      dann einfach stehen, nie eine schwarze Fläche. Läuft einmal durch,
      bleibt auf dem letzten Frame stehen und startet frühestens nach
      30 Sekunden erneut, sofern Seite und Hero weiterhin sichtbar sind.

   2. initAsHeroVideos(): bestehendes Verhalten für alle ANDEREN
      Video-Sections weiter unten auf der Seite (falls vorhanden) — Bild
      wird ausgeliefert, per IntersectionObserver erst beim Näherkommen
      durch ein Video ersetzt, damit sie nicht um Bandbreite mit dem
      sichtbaren Hero konkurrieren. Unverändert gegenüber vorher.

   Beide respektieren dieselbe reduzierte-Bewegung-/Sparmodus-Prüfung
   (siehe bewegungErlaubt()). Idempotent: jedes Element wird nur einmal
   behandelt, auch wenn dieses Skript von mehreren Sections eingebunden
   wird. */
(function () {
  if (window.__asHeroVideoInit) return;
  window.__asHeroVideoInit = true;

  function bewegungErlaubt() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return false;
    }
    var verbindung = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
    if (verbindung) {
      if (verbindung.saveData) return false;
      if (verbindung.effectiveType && /2g/.test(verbindung.effectiveType)) return false;
    }
    return true;
  }

  function initNativeHeroVideos() {
    var videos = document.querySelectorAll('video[data-as-hero-video-native]:not([data-as-hero-video-native-done])');
    videos.forEach(function (video) {
      video.setAttribute('data-as-hero-video-native-done', '');

      if (!bewegungErlaubt()) return;

      video.addEventListener('loadeddata', function () {
        video.classList.add('as-hero-video-bereit');
      });
      video.addEventListener('error', function () {
        video.classList.remove('as-hero-video-bereit');
      });

      var sichtbar = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (eintraege) {
            eintraege.forEach(function (eintrag) {
              sichtbar = eintrag.isIntersecting;
            });
          },
          { rootMargin: '200px 0px' }
        ).observe(video);
      }

      function abspielen() {
        var wiedergabe = video.play();
        if (wiedergabe && wiedergabe.catch) wiedergabe.catch(function () {});
      }

      video.addEventListener('ended', function () {
        window.setTimeout(function () {
          if (!video.isConnected) return;
          if (document.visibilityState !== 'visible') return;
          if (!sichtbar) return;
          video.currentTime = 0;
          abspielen();
        }, 30000);
      });

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState !== 'visible') return;
        if (video.paused && video.ended) abspielen();
      });

      abspielen();
    });
  }

  function initAsHeroVideos() {
    if (!bewegungErlaubt()) {
      return;
    }

    var kannBeobachten = 'IntersectionObserver' in window;

    function videoAbspielen(video) {
      var wiedergabe = video.play();
      if (wiedergabe && wiedergabe.catch) wiedergabe.catch(function () {});
    }

    function heroWiederholenWennSichtbar(video) {
      if (!video.isConnected) return;
      if (video.getAttribute('data-as-hero-neustart-bereit') !== 'true') return;
      if (document.visibilityState !== 'visible') return;
      if (video.getAttribute('data-as-hero-sichtbar') === 'false') return;

      video.removeAttribute('data-as-hero-neustart-bereit');
      video.currentTime = 0;
      videoAbspielen(video);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      document.querySelectorAll('video[data-as-hero-neustart-bereit="true"]').forEach(function (video) {
        heroWiederholenWennSichtbar(video);
      });
    });

    var wiedergabeBeobachter = null;
    if (kannBeobachten) {
      wiedergabeBeobachter = new IntersectionObserver(
        function (eintraege) {
          eintraege.forEach(function (eintrag) {
            var video = eintrag.target;
            if (eintrag.isIntersecting) {
              video.setAttribute('data-as-hero-sichtbar', 'true');
              if (video.getAttribute('data-as-hero-neustart-bereit') === 'true') {
                heroWiederholenWennSichtbar(video);
              } else if (video.getAttribute('data-as-hero-wartet') !== 'true') {
                videoAbspielen(video);
              }
            } else {
              video.setAttribute('data-as-hero-sichtbar', 'false');
              video.pause();
            }
          });
        },
        { rootMargin: '200px 0px' }
      );
    }

    function bildDurchVideoErsetzen(bild) {
      bild.setAttribute('data-as-hero-video-done', '');
      var istMobil = window.matchMedia && window.matchMedia('(max-width: 40rem)').matches;
      var mobileQuelle = bild.getAttribute('data-video-mobile-src');
      var quelle = istMobil && mobileQuelle ? mobileQuelle : bild.getAttribute('data-video-src');
      if (!quelle) return;

      var istEager = bild.getAttribute('data-as-hero-video-eager') === 'true';

      var video = document.createElement('video');
      video.className = bild.className;
      var mobilePoster = bild.getAttribute('data-mobile-poster-src');
      video.setAttribute('poster', istMobil && mobilePoster ? mobilePoster : (bild.currentSrc || bild.src));
      video.autoplay = true;
      video.setAttribute('autoplay', '');
      video.muted = true;
      video.setAttribute('muted', '');
      video.loop = !istEager;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.preload = istEager ? 'auto' : 'metadata';
      video.setAttribute('aria-hidden', 'true');
      video.tabIndex = -1;

      var quellElement = document.createElement('source');
      quellElement.src = quelle;
      quellElement.type = 'video/mp4';
      video.appendChild(quellElement);

      if (istEager) {
        video.addEventListener('ended', function () {
          video.setAttribute('data-as-hero-wartet', 'true');
          window.setTimeout(function () {
            if (!video.isConnected) return;
            video.removeAttribute('data-as-hero-wartet');
            video.setAttribute('data-as-hero-neustart-bereit', 'true');
            heroWiederholenWennSichtbar(video);
          }, 30000);
        });
      }

      var bildRahmen = bild.parentElement && bild.parentElement.hasAttribute('data-as-hero-video-picture')
        ? bild.parentElement
        : bild;
      bildRahmen.replaceWith(video);

      if (wiedergabeBeobachter) {
        wiedergabeBeobachter.observe(video);
      }
    }

    var bilder = document.querySelectorAll('img[data-as-hero-video]:not([data-as-hero-video-done])');
    bilder.forEach(function (bild) {
      if (!kannBeobachten || bild.getAttribute('data-as-hero-video-eager') === 'true') {
        bildDurchVideoErsetzen(bild);
        return;
      }

      // Weiter unten liegende Hero-Videos: erst laden, wenn die Section in
      // die Nähe des Viewports scrollt, statt sie beim Seitenaufruf sofort
      // mit dem sichtbaren Hero-Video um Bandbreite konkurrieren zu lassen.
      var ladeBeobachter = new IntersectionObserver(
        function (eintraege, beobachter) {
          eintraege.forEach(function (eintrag) {
            if (eintrag.isIntersecting) {
              beobachter.unobserve(eintrag.target);
              bildDurchVideoErsetzen(eintrag.target);
            }
          });
        },
        { rootMargin: '800px 0px' }
      );
      ladeBeobachter.observe(bild);
    });
  }

  function initAlle() {
    initNativeHeroVideos();
    initAsHeroVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAlle);
  } else {
    initAlle();
  }
})();
